(function($) {
  'use strict';

  // Document ready
  $(document).ready(function() {
    
    // Mobile menu toggle
    $('.menu-toggle').on('click', function() {
      $(this).toggleClass('activated');
      $(this).next('.genesis-nav-menu').slideToggle('fast').toggleClass('activated');
    });

    // Smooth scroll for anchor links
    $('a[href*="#"]:not([href="#"])').on('click', function() {
      if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && 
          location.hostname === this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 100
          }, 1000);
          return false;
        }
      }
    });

    // Add your custom JavaScript here

    // ── Motif Parallax Effect ──────────────────────────────────
    // Moves [data-motif-effect="parallax"] elements downward as
    // the user scrolls, creating a sunset-like sinking motion.
    var parallaxMotifs = document.querySelectorAll('[data-motif-effect="parallax"]');
    if (parallaxMotifs.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var onScroll = function() {
        parallaxMotifs.forEach(function(el) {
          var hero = el.closest('.hero-section');
          if (!hero) return;
          var rect = hero.getBoundingClientRect();
          var heroHeight = hero.offsetHeight;
          // Only animate while the hero is in view
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          // Progress: 0 at top of viewport, 1 when hero has scrolled past
          var scrolled = Math.max(0, -rect.top);
          var progress = Math.min(scrolled / heroHeight, 1);
          // Move the motif down by up to 40% of hero height
          var offset = progress * heroHeight * 0.4;
          el.style.setProperty('--motif-parallax-y', offset + 'px');
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll(); // initial position
    }

  });

  // Window load
  $(window).on('load', function() {
    // Code to run after page is fully loaded
  });

  // Window resize
  $(window).on('resize', function() {
    // Responsive JavaScript
  });

})(jQuery);


// ── Foundation Page: Scroll Reveal ────────────────────────────
// Observes .fdn-reveal elements and adds .fdn-visible when they
// enter the viewport. Staggers siblings for cascading effect.
(function() {
  var reveals = document.querySelectorAll('.fdn-reveal');
  if (!reveals.length) return;

  // Respect reduced-motion preference.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    reveals.forEach(function(el) { el.classList.add('fdn-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        // Stagger siblings for cascade effect.
        var siblings = entry.target.parentElement.querySelectorAll('.fdn-reveal');
        var delay = 0;
        siblings.forEach(function(sib) {
          if (sib === entry.target) {
            entry.target.style.transitionDelay = delay + 'ms';
          }
          delay += 80;
        });
        entry.target.classList.add('fdn-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  reveals.forEach(function(el) { observer.observe(el); });
})();

// Testimonials Slider
document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.testimonials-slider');
  
  sliders.forEach(slider => {
    const track = slider.querySelector('.testimonials-track');
    const items = slider.querySelectorAll('.testimonial-item');
    const prevBtn = slider.querySelector('.testimonials-prev');
    const nextBtn = slider.querySelector('.testimonials-next');
    const dotsContainer = slider.querySelector('.testimonials-dots');
    
    if (items.length <= 1) return;
    
    let currentIndex = 0;
    
    // Create dots
    items.forEach((_, index) => {
      const dot = document.createElement('span');
      dot.className = `dot ${index === 0 ? 'active' : ''}`;
      dot.addEventListener('click', () => goToSlide(index));
      dotsContainer.appendChild(dot);
    });
    
    const dots = dotsContainer.querySelectorAll('.dot');
    
    function updateSlider() {
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
      });
    }
    
    function goToSlide(index) {
      currentIndex = index;
      updateSlider();
    }
    
    function nextSlide() {
      currentIndex = (currentIndex + 1) % items.length;
      updateSlider();
    }
    
    function prevSlide() {
      currentIndex = (currentIndex - 1 + items.length) % items.length;
      updateSlider();
    }
    
    prevBtn.addEventListener('click', prevSlide);
    nextBtn.addEventListener('click', nextSlide);
    
    // Auto-advance every 5 seconds
    setInterval(nextSlide, 5000);
  });
});